export default {
  setQuizsets (state, quizsets) {
    state.quizsets = quizsets
  },

  setQuizset (state, quizset) {
    state.quizset = quizset
  },

  setName (state, name) {
    state.name = name
  },

  setMap (state, map) {
    state.map = map
  },

  setMapChanged (state, mapChanged) {
    state.mapChanged = mapChanged
  }
}
